import { computed, ref, Ref, unref } from 'vue'
import {
  BatchViewFilter,
  FieldViewFilter,
  JobFilter,
  JobNumberFilter,
  JobQueueFilter,
  ProjectViewFilter,
} from '@/components/jobs/filters'

type SortInfo = {
  sortBy: Ref<string[]>
  sortDesc: Ref<boolean[]>
}

type OffsetInfo = {
  offset: Ref<number>
  limit: number
}

export type ArchivedFilter = { archived: boolean }

export type AssignmentGroupFilter = { assignmentGroupNumber: number }

export type SearchJobsQuery = (
  | JobFilter
  | JobQueueFilter
  | JobNumberFilter
  | ProjectViewFilter
  | BatchViewFilter
  | FieldViewFilter
  | AssignmentGroupFilter
  | ArchivedFilter
) &
  SortInfo &
  OffsetInfo

export type SearchJobsCountQuery =
  | JobFilter
  | JobQueueFilter
  | JobNumberFilter
  | ProjectViewFilter
  | BatchViewFilter
  | FieldViewFilter
  | AssignmentGroupFilter
  | ArchivedFilter

export function useJobsQuery(
  filters:
    | JobFilter
    | JobQueueFilter
    | JobNumberFilter
    | ProjectViewFilter
    | BatchViewFilter
    | FieldViewFilter
    | AssignmentGroupFilter
    | ArchivedFilter,
  currentPage: Ref<number>,
  itemsPerPage: Ref<number>,
  sortBy: Ref<string[]> = ref<string[]>([]),
  sortDesc: Ref<boolean[]> = ref<boolean[]>([]),
): SearchJobsQuery {
  const offset = computed(() => (currentPage.value - 1) * itemsPerPage.value)

  return {
    ...filters,
    sortBy,
    sortDesc,
    offset,
    limit: unref(itemsPerPage),
  }
}

export function useJobsCountQuery(
  filters:
    | JobFilter
    | JobQueueFilter
    | JobNumberFilter
    | ProjectViewFilter
    | BatchViewFilter
    | FieldViewFilter
    | AssignmentGroupFilter
    | ArchivedFilter,
): SearchJobsCountQuery {
  return filters
}
